import { ActionType } from "@sp-crm/core";
import { RegionVisibilityTree } from "components/ui/region-visibility-tree";
import { RegionVisibility } from "components/ui/region-visibility-tree/tree-utils";
import { BridgeQuestionInput } from "generated/graphql";
import React, { useCallback, useMemo } from "react";

interface QuestionRegionInputProps {
    question: BridgeQuestionInput;
    onChange: (question: BridgeQuestionInput) => void;
    editable: boolean;
}

export const QuestionRegionInput: React.FC<QuestionRegionInputProps> = props => {
    const { editable, question, onChange } = props;

    const regionVisibility: RegionVisibility[] = useMemo(() => {
        return (
            question.regionVisibility?.regions?.map(r => ({
                regionId: r.regionId,
                mode: r.mode,
            })) ?? []
        );
    }, [question.regionVisibility]);

    const handleChange = useCallback(
        (regions: RegionVisibility[]) => {
            onChange({
                ...question,
                regionVisibility: {
                    regions: regions.map(r => ({
                        regionId: r.regionId,
                        mode: r.mode,
                    })),
                },
            });
        },
        [onChange, question],
    );

    return (
        <RegionVisibilityTree
            actionType={ActionType.UpdateQuestion}
            label="Office visibility"
            editable={editable}
            regionVisibility={regionVisibility}
            onChange={handleChange}
            entityName="field"
        />
    );
};
